import React from 'react';
import PropTypes from 'prop-types';
import PublicationCell from '../publicationCell/PublicationCell';

import { publicationTypes } from '../../PublicationsParser';

import './PublicationListSection.css';


const PublicationListSection = (props) => {
  const { publicationType, publications, publicationYear } = props;

  return (
    <div id="listSection">
      <div id="sectionTitle">
        <h1>{publicationYear}</h1>
        <div id="sectionType">
          <h2>{publicationTypes[publicationType]}</h2>
        </div>
      </div>
      <div id="sectionList">
        {
          publications.map(publication => (
            <PublicationCell
              publication={publication}
              key={`${publication.title}-${publication.type}`}
            />
          ))
        }
      </div>
    </div>
  );
};

PublicationListSection.propTypes = {
  publicationType: PropTypes.string.isRequired,
  publicationYear: PropTypes.string,
  publications: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string.isRequired,
      forum: PropTypes.string.isRequired,
      authors: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

PublicationListSection.defaultProps = {
  publicationYear: '',
};

export default PublicationListSection;
